"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _emotion = require("../utils/emotion");
var _useTheme = _interopRequireDefault(require("./useTheme.hook"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialHash = {
  hash: '',
  name: ''
};
var useCss = function useCss(props) {
  var theme = (0, _useTheme["default"])();
  var stateRef = (0, _react.useRef)(_objectSpread({}, initialHash));
  var defaultStyles = (0, _react.useMemo)(function () {
    return _objectSpread({
      boxSizing: 'border-box'
    }, theme.scroll());
  }, []);
  var cssProps = (0, _react.useMemo)(function () {
    if (typeof props === 'function') {
      var result = props(theme);
      return _objectSpread(_objectSpread({}, defaultStyles), result);
    }
    return _objectSpread(_objectSpread({}, defaultStyles), props);
  }, [defaultStyles, props, theme]);
  var className = (0, _react.useMemo)(function () {
    var newHash = JSON.stringify(cssProps);
    if (stateRef.current.hash === newHash) {
      return stateRef.current.name;
    }
    var newName = (0, _emotion.css)(cssProps);
    stateRef.current.hash = newHash;
    stateRef.current.name = newName;
    return newName;
  }, [cssProps]);
  return className;
};
var _default = useCss;
exports["default"] = _default;